<template>
  <div :class="['editor-toolbar', toolbarClass]">
    <span class="ql-formats">
      <select class="ql-size">
        <option value="10px">Small</option>
        <option selected>Normal</option>
        <option value="18px">Large</option>
        <option value="32px">Huge</option>
      </select>
      <select class="ql-color"></select>
      <select class="ql-background"></select>
      <button class="ql-bold" data-tooltip="bold"></button>
      <button class="ql-italic" data-tooltip="italic"></button>
      <button class="ql-strike" data-tooltip="strike"></button>
      <button class="ql-code-block" data-tooltip="code block"></button>
      <button class="ql-list" value="ordered" data-tooltip="ordered list"></button>
      <button class="ql-list" value="bullet" data-tooltip="bullet list"></button>
      <button class="ql-indent" value="-1" data-tooltip="indent left"></button>
      <button class="ql-indent" value="+1" data-tooltip="indent right"></button>
      <button class="ql-direction" value="rtl" data-tooltip="rtl direction"></button>
      <select class="ql-align" data-tooltip="text align"></select>
      <button class="ql-link" data-tooltip="insert link"></button>
      <button v-if="canInsertImages"
              :class="['ql-image', { ['image-open']: showImages }]"
              data-tooltip="insert image"></button>
      <button class="ql-clean" data-tooltip="clean remove"></button>
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      canInsertImages: Boolean,
      showImages: Boolean,
      toolbarClass: String,
    },

    name: 'QuillToolbar',
  }
</script>